import { render, staticRenderFns } from "./TooltipModal.vue?vue&type=template&id=0def7fdd&scoped=true"
import script from "./TooltipModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TooltipModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TooltipModal.vue?vue&type=style&index=0&id=0def7fdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def7fdd",
  null
  
)

export default component.exports